import React from 'react';

import { componentService } from '@core/js/services/component.service';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TDividerProps } from './types';

import style from './Divider.scss';

export const Divider: React.FC<TDividerProps> = ({ className, top, bottom, height }) => (
    <div
        data-testid="Divider_block"
        style={{
            marginTop: top,
            marginBottom: bottom,
            height
        }}
        className={clsx(style.divider, className)}
    />
);

componentService.registerWebContentComponents({ Divider });
